import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import "./Style.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaClock } from "react-icons/fa";

const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        topic: "",
        message: "",
    });

    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("https://d-api.dotlocalhost.com/contact.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (result.success) {
                setStatus("Message sent successfully!");
                setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    topic: "",
                    message: "",
                });
            } else {
                setStatus("Failed to send message. Please try again.");
            }
        } catch (error) {
            setStatus("An error occurred. Please try again later.");
        }
    };

    return (
        <>
            {/* Meta title and descriptions */}
            <Helmet>
                <title>Contact DotLocalHost - Get in Touch for Web & Hosting Support</title>
                <meta
                    name="description"
                    content="Reach out to DotLocalHost today! Contact us for expert web development, hosting inquiries, or support. Let’s bring your vision to life!"
                />
            </Helmet>
            <div className="company-section py-5">
                <div className="container">

                    <div className="contact-us-container">
                        {/* Left Section - Contact Info */}
                        <div className="contact-info">
                            <h3>CONTACT US</h3>
                            <h1>Let’s work together</h1>
                            <p>
                                Thank you for your interest in Attach Web Agency. We're excited to
                                hear from you and discuss...
                            </p>

                            <div className="contact-item">
                                <FaMapMarkerAlt className="icon" />
                                <div>
                                    <h4>Our Address</h4>
                                    <p>6026 Fair Oaks Blvd, Carmichael, California, 95608, United States</p>
                                </div>
                            </div>

                            <div className="contact-item">
                                <FaPhoneAlt className="icon" />
                                <div>
                                    <h4>Phone Number</h4>
                                    <p>+1 209 213 3438</p>
                                    <p>webdev@dotlocalhost.com</p>
                                </div>
                            </div>

                            <div className="contact-item">
                                <FaClock className="icon" />
                                <div>
                                    <h4>Hours of Operation</h4>
                                    <p>MON-FRI: 09.00 AM TO 6.30 PM</p>
                                </div>
                            </div>
                        </div>

                        {/* Right Section - Contact Form */}
                        <div className="contact-form">
                            <form onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <input
                                        type="text"
                                        name="firstName"
                                        placeholder="First Name*"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required
                                    />
                                    <input
                                        type="text"
                                        name="lastName"
                                        placeholder="Last Name*"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-row">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email address*"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Phone number*"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-row">
                                    <select
                                        name="topic"
                                        value={formData.topic}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Query Topic</option>
                                        <option value="General Inquiry">General Inquiry</option>
                                        <option value="Support">Support</option>
                                        <option value="Collaboration">Collaboration</option>
                                    </select>
                                </div>
                                <div className="form-row">
                                    <textarea
                                        name="message"
                                        placeholder="Message*"
                                        rows="5"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>
                                <button type="submit">Submit Message</button>
                                {status && <p className="form-status">{status}</p>}
                            </form>
                        </div>
                    </div>

                    {/* Google Map Embed Section */}
                    <div className="google-map-container py-5 mt-5">

                        <div className="map-embed">
                            <iframe
                                width="100%"
                                height="450"
                                frameBorder="0"
                                style={{ border: 0 }}
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3117.6509547981273!2d-121.33098112353383!3d38.61090336355696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809adc4178990c85%3A0xc02c2160ccc18021!2s6026%20Fair%20Oaks%20Blvd%2C%20Carmichael%2C%20CA%2095608%2C%20USA!5e0!3m2!1sen!2s!4v1763488828212!5m2!1sen!2s"
                                allowFullScreen=""
                                aria-hidden="false"
                                tabIndex="0"
                            ></iframe>
                        </div>
                    </div>

                </div>
            </div>

        </>
    );
};

export default Contact;
